export const SET_IS_LOADING = "PROPERTIES/SET_IS_LOADING";
export const SET_PROPERTY_LIST = "PROPERTIES/SET_PROPERTY_LIST";
export const SET_SEARCH = "PROPERTIES/SET_SEARCH";
